import { Command } from "src/app/shared/ddd/models/command";
import { FormFieldChange } from "../../components/item-form/dynamic-form-actions-base";

export class ItemFieldChangeCommand implements Command {
  fieldChange: FormFieldChange;

  constructor(fieldChange: FormFieldChange) {
    this.fieldChange = fieldChange;
  }
}
